import React from 'react'
import cx from 'classnames'

import s from './ToggleArrow.scss'


const ToggleArrow = ({ direction }) => (
  <div
    className={cx(s.arrow, {
      [s.down]: direction === 'down',
      [s.left]: direction === 'left',
      [s.right]: direction === 'right',
    })}
  />
)


export default ToggleArrow
